import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
  body {
    /* font-family: 'Oswald', sans-serif; */
    font-family: 'Open Sans', sans-serif;
    color: #333333;
    font-weight:100;
    text-rendering: optimizeLegibility;
    line-height: 1.88;
    font-weight: 400;
    font-size: 15px;
  }
  .video-responsive {
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    padding-top: 30px;
    position: relative;
    }
.video-responsive iframe, .video-responsive object, .video-responsive embed {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    }


`

export default GlobalStyle